module.exports = __webpack_public_path__ + "img/gwnu_main1.e4170aef.jpg";